/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LootboxTransactionPagination } from './LootboxTransactionPagination';
import {
    LootboxTransactionPaginationFromJSON,
    LootboxTransactionPaginationFromJSONTyped,
    LootboxTransactionPaginationToJSON,
    LootboxTransactionPaginationToJSONTyped,
} from './LootboxTransactionPagination';
import type { LootboxTransactionHistoryItem } from './LootboxTransactionHistoryItem';
import {
    LootboxTransactionHistoryItemFromJSON,
    LootboxTransactionHistoryItemFromJSONTyped,
    LootboxTransactionHistoryItemToJSON,
    LootboxTransactionHistoryItemToJSONTyped,
} from './LootboxTransactionHistoryItem';

/**
 * 
 * @export
 * @interface LootboxTransactionHistoryResponse
 */
export interface LootboxTransactionHistoryResponse {
    /**
     * 
     * @type {Array<LootboxTransactionHistoryItem>}
     * @memberof LootboxTransactionHistoryResponse
     */
    transactions?: Array<LootboxTransactionHistoryItem>;
    /**
     * 
     * @type {LootboxTransactionPagination}
     * @memberof LootboxTransactionHistoryResponse
     */
    pagination?: LootboxTransactionPagination;
    /**
     * Applied time filter
     * @type {string}
     * @memberof LootboxTransactionHistoryResponse
     */
    timeFilter?: string;
    /**
     * Start date of filter period
     * @type {Date}
     * @memberof LootboxTransactionHistoryResponse
     */
    startDate?: Date;
    /**
     * End date of filter period
     * @type {Date}
     * @memberof LootboxTransactionHistoryResponse
     */
    endDate?: Date;
}

/**
 * Check if a given object implements the LootboxTransactionHistoryResponse interface.
 */
export function instanceOfLootboxTransactionHistoryResponse(value: object): value is LootboxTransactionHistoryResponse {
    return true;
}

export function LootboxTransactionHistoryResponseFromJSON(json: any): LootboxTransactionHistoryResponse {
    return LootboxTransactionHistoryResponseFromJSONTyped(json, false);
}

export function LootboxTransactionHistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LootboxTransactionHistoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'transactions': json['transactions'] == null ? undefined : ((json['transactions'] as Array<any>).map(LootboxTransactionHistoryItemFromJSON)),
        'pagination': json['pagination'] == null ? undefined : LootboxTransactionPaginationFromJSON(json['pagination']),
        'timeFilter': json['timeFilter'] == null ? undefined : json['timeFilter'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
    };
}

export function LootboxTransactionHistoryResponseToJSON(json: any): LootboxTransactionHistoryResponse {
    return LootboxTransactionHistoryResponseToJSONTyped(json, false);
}

export function LootboxTransactionHistoryResponseToJSONTyped(value?: LootboxTransactionHistoryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transactions': value['transactions'] == null ? undefined : ((value['transactions'] as Array<any>).map(LootboxTransactionHistoryItemToJSON)),
        'pagination': LootboxTransactionPaginationToJSON(value['pagination']),
        'timeFilter': value['timeFilter'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
    };
}

